import { SET_FEATURES } from './types';
export default {
  [SET_FEATURES](state, features) {
    state.features = features;
  }
};